import React from 'react'
import cx from 'classnames'

import styles from './Box.module.scss'

export const Box = React.forwardRef(
  (
    {
      ariaLabel,
      ariaRole,
      align,
      children,
      className = undefined,
      direction = 'row',
      justify,
      style,
      tagName,
      shouldWrapContent,
      onClick,
      componentId,
    },
    ref,
  ) => {
    const Component = tagName ?? 'div'

    return (
      <Component
        aria-label={ariaLabel}
        onClick={onClick}
        id={componentId}
        className={cx(
          styles.box,
          styles.align,
          styles.direction,
          styles.justify,
          {
            [styles[`align-${align}`]]: Boolean(align),
            [styles[`direction-${direction}`]]: Boolean(direction),
            [styles[`justify-${justify}`]]: Boolean(justify),
            [styles.wrap]: shouldWrapContent,
            [className]: Boolean(className),
          },
        )}
        role={ariaRole}
        {...{ ref, style }}
      >
        {children}
      </Component>
    )
  },
)
